import { Box } from "@chakra-ui/react";
import ArrivalRatesPerServiceTable from "../../tables/daily/ArrivalRatesPerServiceTable";
import EnterpriseReportSummary from "../../../reports/EnterpriseReportSummary";
import { buildArrivalInsights } from "../../../../store/reportEnterpriseInsights";


const BranchArrivalRatesPerService = ({ reportIndex, data, renderConfig }) => {
  return (
    <Box>
      {data.map(({ branchName, servicesData }, branchIndex) => {
        const title = `${reportIndex || ""}.${branchIndex + 1}. ${branchName}`;
        const insights = buildArrivalInsights(servicesData, { scopeLabel: "Service" });
        return (
          <>
            <h2>{title}</h2>
            <EnterpriseReportSummary
              title="Daily Service Arrival Demand Summary"
              kpis={insights.kpis}
              tables={insights.tables}
              notes={insights.notes}
            />
            {servicesData.map((data, index) => {
              return (
                <ArrivalRatesPerServiceTable
                  key={index}
                  index={index}
                  data={data}
                  branchIndex={branchIndex}
                  reportIndex={reportIndex}
                  branchName={branchName}
                  renderConfig={renderConfig}
                />
              );
            })}
          </>
        );
      })}
    </Box>
  );
};

export default BranchArrivalRatesPerService;
